import { Component, Inject, ElementRef, OnInit, Input, Output, Renderer2, inject, EventEmitter, input, AfterViewInit, ViewChild } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { COMMON_MODULES, ROUTES } from '@src/app/core/constants';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { filter, Subscription } from 'rxjs';
import { HelperService, LocalStorageService, SharedDataService } from '@src/app/core/services';
import { StorageService } from '@src/app/core/services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CONNREFUSED } from 'dns';
import { AppModeState } from '@src/app/core/ngxs/actions/app-mode.state';
import { Store } from '@ngxs/store';
declare var $: any;

@Component({
  selector: 'app-minienv-navbar',
  standalone: true,
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  imports: [...COMMON_MODULES, NgbDropdownModule, TranslateModule, HttpClientModule],
})
export class MiniEnvNavbarComponent implements OnInit, AfterViewInit {
  public routes = ROUTES
  public user: any;
  isnavbar = false;
  @Output() navbarChange = new EventEmitter<boolean>();
  localStorageService = inject(LocalStorageService)
  sharedService = inject(SharedDataService)
  isUser: boolean = false
  isLoginPage: boolean = false;
  isRegisterPage: boolean = false;
  currentRoute: any = '';
  userInfo: any;
  hasWellnessMembership: boolean = false;
  helperService = inject(HelperService)
  storageService = inject(StorageService)
  //Warning error variables
  showFutureServiceErr = false;
  errMsg = 'some msg';
  containerStyle = 'padding: 0';
  msgBodyStyle = 'border-radius: 0';
  headerLogo = "";
  headerLogoNormal = "";
  headerLogoTransparent = "";
  headerLogoMob = "";
  headerLogoMobNormal = "";
  headerLogoMobTransparent = "";
  headerPhoneNumber = "";
  headerLogoWidth = 250;
  headerLogoWidthMob = 136;
  phoneFiller = '#FFFFFF'
  landingPage = "";
  config: any;
  routerSub!: Subscription;
  isAcaPage: boolean = false
  isScrolled: any;
  isAuthPage: boolean = false;
  forcesDefaultLoginLogos : boolean = false;
  isUserLoggedIn = false;
  isMiniEnvLandingPage: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private translate: TranslateService,
    public sharedDataService: SharedDataService,
    private store: Store,
    public activeRoute: ActivatedRoute
  ) {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe((event: any) => {
        if (event instanceof NavigationEnd && this.currentRoute !== event.url) {
          this.currentRoute = event.url;
          this.shouldShowMenu(event.urlAfterRedirects || event.url);
        }
      });

    this.shouldShowMenu(window.location.href);


    const config = this.store.selectSnapshot(AppModeState.envConfig);
      //  if loggedOut then normal icons like headerDesktopLogoTransparent
      // else  other logos that are provided
    const hasToken = !!this.storageService.getUserInformation();
    this.isUserLoggedIn = hasToken;
    this.isUser = hasToken;
    if (hasToken && !config?.forcesDefaultLoginLogos) {
        this.headerLogoTransparent = config?.headerDesktopLogoTransparentlogin || '';
        this.headerLogoNormal = config?.headerDesktopLogologin || '';

        this.headerLogoMobTransparent = config?.headerMobileLogoTransparentLogin || '';
        this.headerLogoMobNormal = config?.headerMobileLogoLogin || '';
        this.headerLogoWidth = config?.headerLogoWidthLogin || 250;

        this.headerLogo = this.headerLogoTransparent;
        this.headerLogoMob = this.headerLogoMobTransparent;
        this.headerLogoWidthMob = config?.headerLogoWidthMobLogin || 136;
        this.headerPhoneNumber = config?.headerPhoneNumber || "";
    }
      //  in the else cause the normal mini-env  logos will be shown 
      else {
        this.headerLogoTransparent = config?.headerDesktopLogoTransparent || '';
        this.headerLogoNormal = config?.headerDesktopLogo || '';

        this.headerLogoMobTransparent = config?.headerMobileLogoTransparent || '';
        this.headerLogoMobNormal = config?.headerMobileLogo || '';
        this.headerLogoWidth = config?.headerLogoWidth || 250;

        this.headerLogo = this.headerLogoTransparent;
        this.headerLogoMob = this.headerLogoMobTransparent;
        this.headerLogoWidthMob = config?.headerLogoWidthMob || 136;
        this.headerPhoneNumber = config?.headerPhoneNumber || "";

        this.landingPage = config?.landingPage || '';
      }
      
  }
  @ViewChild('topmenu') headerRef!: ElementRef<HTMLElement>;
  isLandingPage = false;
  scrollHandler!: () => void;

  ngAfterViewInit(): void {
    
    const header = this.headerRef.nativeElement;
    const pageContent = document.querySelector<HTMLElement>('.page-content');

    // ---------- ROUTE CHANGE HANDLER ----------
    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const route = event.urlAfterRedirects.split('?')[0];
        this.updateLandingState(route, header, pageContent);
        // Sync logo state with current scroll position after route change
        setTimeout(() => this.scrollHandler(), 0);
      });

    // ---------- INITIAL LOAD ----------
    const initialRoute = this.router.url.split('?')[0];
    this.updateLandingState(initialRoute, header, pageContent);

    // ---------- SCROLL HANDLER ----------
    this.scrollHandler = () => {
      if (this.isUserLoggedIn ) {
        header.classList.add('scrolled');
        this.phoneFiller = '#000000';
        this.setNormalLogos();
        return;
      }

      if (!this.isLandingPage) {
        this.isScrolled = window.scrollY > 50;
      }

       else {
        if (window.scrollY > 50) {
          header.classList.add('scrolled');
          this.phoneFiller = '#000000'
          this.setNormalLogos();
        } else {
          header.classList.remove('scrolled');
          this.phoneFiller = '#FFFFFF'
          this.setTransparentLogos();
        }
      }
    };

    window.addEventListener('scroll', this.scrollHandler);
  }
  private updateLandingState(route: string, header: HTMLElement, pageContent: HTMLElement | null) {
    // Match the landing page on a path boundary so e.g. "/tru-access-account"
    // isn't treated as the "/tru" landing page (which kept the navbar transparent).
    this.isLandingPage = route === this.landingPage || route.startsWith(this.landingPage + '/');
    pageContent?.classList.toggle('minienv-landingpage', this.isLandingPage && !this.isUserLoggedIn && this.storageService.getMiniEnvConfig());
    document.body.classList.toggle('minienv-landingpage-body', this.isLandingPage || this.storageService.getMiniEnvConfig());
    if (this.isUserLoggedIn ) {
      header.classList.add('scrolled');
      this.phoneFiller = '#000000';
      this.setNormalLogos();
      return;
    }

    if (this.isLandingPage) {
      this.setTransparentLogos();
      header.classList.remove('scrolled');
    }
    else {
      this.isScrolled = true
      this.setNormalLogos();
      if (!this.storageService.getMiniEnvConfig()) {
        header.classList.remove('scrolled');
      } else {
        header.classList.add('scrolled');
      }
    }
  }
  primaryButtonClick(primaryButtonLink: string) {
    if (!primaryButtonLink) return;
    const isHash = primaryButtonLink.includes('#');
    const isExternal = /^https?:\/\//i.test(primaryButtonLink);
    // for extrnal redirection link like cehas ssp amac /
    if (isExternal || isHash) {
      window.location.href = primaryButtonLink;
      const section : any = document.getElementById(primaryButtonLink.split("#")[1]);
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    else{
      this.isnavbar = false;
      this.router.navigateByUrl(primaryButtonLink);
    }
  }
  private setTransparentLogos() {
    this.headerLogo = this.headerLogoTransparent;
    this.headerLogoMob = this.headerLogoMobTransparent;
  }

  private setNormalLogos() {
    this.headerLogo = this.headerLogoNormal;
    this.headerLogoMob = this.headerLogoMobNormal;
  }

  ngOnDestroy(): void {
    window.removeEventListener('scroll', this.scrollHandler);
    this.routerSub?.unsubscribe();
  }
  private shouldShowMenu(url: string): void {
    // Implement your logic to determine when to show/hide the menu based on the route
    // For example, you can check if the route is '/login' or '/dashboard'
    this.isUser = this.storageService.getUserInformation() ? true : false
    this.isLoginPage = url.includes('/login');
    this.isRegisterPage = url.includes('/register');
    this.isRegisterPage = url.includes('/reset-password');
    if (url.includes('/forgot')) {
      this.isRegisterPage = url.includes('/forgot');
    }
  }
  get userInitials(): string {
    this.userInfo = this.storageService.getUserInformation()
    const firstInitial = this.userInfo.firstName?.charAt(0).toUpperCase() || '';
    const lastInitial = this.userInfo.lastName?.charAt(0).toUpperCase() || '';
    return `${firstInitial}${lastInitial}`;
  }
  navigateToHome() {
    window.location.replace(this.routes.home)
  }
  ngOnInit(): void {
    this.checkLandingPage(this.router.url);    
    this.hasWellnessMembership = localStorage.getItem('hasWellnessMembership') === 'true';
    let storedData = localStorage.getItem('miniEnvConfig');
    let parsedData = JSON.parse(storedData || '{}');
    let name = parsedData.name;
    if (name === 'Aca wellness') {
      this.hasWellnessMembership = true;
    }
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      this.checkLandingPage(event.urlAfterRedirects);
    });
    
    console.log("i am checking the page", this.landingPage)
    this.activeRoute.url.subscribe(
      (url: any) => {
        this.isAuthPage = ['auth', 'tru-access-account', 'cehas-access-account'].some(path => this.router.url.includes(path));
      }
    )
    if (this.landingPage.includes('acawellness')) {

      this.isAcaPage = true
    } else {
      this.isAcaPage = false
    }
    this.config = this.storageService.getAppModel().envConfig
    this.loadLanguage();
  }
  checkLandingPage(url: string) {
    this.isMiniEnvLandingPage = url.includes(this.landingPage);
  }

  /**
   * Sidebar toggle on hamburger button click
   */
  toggleSidebar(e: Event) {
    e.preventDefault();
    this.document.body.classList.toggle('sidebar-open');
  }

  hideError(e: any) {
    this.showFutureServiceErr = false;
  }

  /**
   * Logout
   */
  onLogout(e: Event) {
    e.preventDefault();
    localStorage.removeItem('isLoggedin');

    if (!localStorage.getItem('isLoggedin')) {
      this.router.navigate(['/auth/login']);
    }
  }
  toggleNavbar() {
    this.isnavbar = !this.isnavbar;
    this.navbarChange.emit(this.isnavbar);
    if (this.isnavbar) {
      $('body').removeClass('minienv-landingpage-body');
      this.phoneFiller = '#000000'
      this.setNormalLogos()
      window.removeEventListener('scroll', this.scrollHandler);
    }
    else {
      $('body').addClass('minienv-landingpage-body');
      this.scrollHandler()
      window.addEventListener('scroll', this.scrollHandler);
    }
  }
  navclose() {
    this.isnavbar = false;
    this.navbarChange.emit(this.isnavbar);
    console.log(this.isnavbar, 'navbar value');

  }

  get phoneHref(): string {
    if (!this.headerPhoneNumber) return '';
    return 'tel:' + this.headerPhoneNumber.replace(/[^0-9+]/g, '');
  }

  closeNavbar(navbar: HTMLElement) {
    if (window.innerWidth < 992) { // only collapse on mobile
      const bsCollapse = new (window as any).bootstrap.Collapse(navbar, { toggle: false });
      bsCollapse.hide();
    }
  }
  isDropdownOpen = false;

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  selectLang(lang: string) {
    console.log("Selected:", lang);

    this.isDropdownOpen = false; // select ke baad close
  }
  currentLanguage: string = 'en';
  public setLanguage(event: any) {
    const ln = event;

    const lang = { code: ln };
    this.currentLanguage = ln;
    this.localStorageService.setDataInLocalStorage({ key: 'language', value: lang }, false);
    this.reloadCurrentRoute();
    this.sharedService.setUserLanguage(ln);
    this.sharedService.setAppConfig();
    console.log(ln, 'selected language');
    console.log(this.sharedService.currentLanguage, 'current language');
    console.log(this.currentLanguage + 'code');
    // this.sharedService.currentLanguage = ln;
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url; this.router.navigateByUrl(ROUTES.resolver, { skipLocationChange: true }).then(() => { this.router.navigate([currentUrl]); });
  }
  loadLanguage() {
    const storedLang = this.localStorageService.getDataInLocalStorage('language', false);
    const ln = storedLang ? storedLang.code : 'en';
    this.currentLanguage = ln;
    this.translate.setDefaultLang('en');
    this.translate.use(ln);
    console.log(this.currentLanguage, 'current language in load language');
  }
}
